import React from 'react';
import { Table } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import RowDeleteButton from '@/components/buttons/RowDeleteButton';
import NameCell from '@/components/table/NameCell';
import formObjectSummaryFields, { formObjectSummaryKeys } from '../helper';
import { typedValue } from '../../helper';
import FormObjectCells from './FormObjectCells';

const FormObjectRow = ({
  allowRemove,
  canEdit,
  className,
  code,
  deleteItem,
  field,
  item,
  onChange,
  showItem,
}) => {
  const intl = useIntl();
  const [primaryField] = formObjectSummaryFields(field);
  return (
    <Table.Row className={`aridhia-form-object-row ${className}`} verticalAlign="top">
      <NameCell
        href={showItem ? '#' : undefined}
        name={typedValue(item[primaryField.name], intl, primaryField)}
        onClick={showItem}
      />
      <FormObjectCells
        canEdit={canEdit}
        code={code}
        field={field}
        item={item}
        keyPrefix={formObjectSummaryKeys(field, item, `form_object_row_cell_${code}_`)}
        onChange={onChange}
      />
      {canEdit && (
        <Table.Cell singleLine textAlign="right">
          <RowDeleteButton
            dataPosition="left center"
            disabled={!allowRemove}
            entity="catalogue.object"
            onClick={deleteItem}
          />
        </Table.Cell>
      )}
    </Table.Row>
  );
};

export default FormObjectRow;
